import gql from 'graphql-tag';

export default gql`
    mutation SaveDriver($input: SaveDriverInput) {
        saveDriver(input: $input) {
            errors
        }
    }
`;
